import { useEffect } from 'react'

import { EDITOR_TOOLS } from '@editor/config/constants'
import AttentionText from '@editor/pages/projects/common/AttentionText/AttentionText'
import { setAttentionText } from '@editor/pages/projects/common/AttentionText/store/attentionText'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { Steps } from '../definitions'
import { LOCAL_FLAGS, setCurrentStep } from '../store'

const StepsManager = () => {
  // Store
  const dispatch = useAppDispatch()
  const currentStep = useSelector((state: RootState) => state.pcdAlignment.currentStep)
  const leftAnchors = useSelector((state: RootState) => state.pcdAlignment.leftAnchors)
  const rightAnchors = useSelector((state: RootState) => state.pcdAlignment.rightAnchors)

  /**
   * Determine the current step from placed anchors.
   */
  useEffect(() => {
    const minAnchors = Math.min(leftAnchors.length, rightAnchors.length)
    const maxAnchors = Math.max(leftAnchors.length, rightAnchors.length)

    if (minAnchors < 3) {
      LOCAL_FLAGS.ignoreLeftCheck = true
      dispatch(setCurrentStep(Steps.SelectPoints))
    } else if (minAnchors === 3 && maxAnchors === 3) {
      LOCAL_FLAGS.ignoreLeftCheck = true
      dispatch(setCurrentStep(Steps.FineTuneOrSave))
    }
  }, [leftAnchors, rightAnchors, dispatch])

  /**
   * Show attention text based on the current step.
   */
  useEffect(() => {
    if (currentStep === Steps.SelectPoints) {
      dispatch(
        setAttentionText({
          message:
            // 'Place 3 anchors on the same physical location for both pointcloud.'
            'それぞれの点群の対応する3つの点を選択してください。',
          tutorialVideo: {
            toolType: EDITOR_TOOLS.PCD_ALIGNMENT,
            linkMessage: '選択する点についてはこちらをご覧ください。',
          },
        }),
      )
    } else if (currentStep === Steps.FineTuneOrSave) {
      dispatch(
        setAttentionText({
          message:
            // 'Confirm the alignment. If you wish to make adjustment, you can redo by clicking Reset. To save the alignment click Save at bottom right of the screen.',
            '位置合わせを確認してください。調整が必要な場合は、リセットをクリックしてやり直すことができます。\n保存するには、画面右下の保存をクリックしてください。',
        }),
      )
    } else {
      dispatch(setAttentionText({ message: '' }))
    }
  }, [leftAnchors, currentStep, dispatch])

  return <AttentionText />
}

export default StepsManager
